<template>
  <list-layout :tableTools="toggleTableTools">
    <template slot="header">
      <BaseHeader :content="header" />
    </template>
    <template slot="table-core">
      <base-table-pagination
        :total="pagination.total"
        :currentPage="pagination.currentPage"
        :perPage="pagination.pageSize"
        @changeCurrentPage="changeCurrentPage"
        @changePerPage="changePerPage"
      ></base-table-pagination>
      <div class="flex flex-row w-100">
        <base-table-searches @toggleSearchesDialog="toggleSearchesDialog" />
        <base-table-search @toggleFilters="toggleFilters" />
      </div>
    </template>
    <template slot="table-tags">
      <base-table-filter-tags  :tags="tags" @removeTag="removeFilterTagHanlder" @removeAllTags="removeAllTagsHandler" @saveTags="saveTagsHandler"/>
    </template>
    <template slot="table-component">
      <kendo-grid-component
        ref="grid"
        v-model="selected"
        value-key="IdCIFEmpresa"
        :id-vista="idVista"
        :spanish="spanish"
        :data='data'
        :kendo="kendo"
        :loading='isGeneralLoading'
        :selectedField="selectedField"
        @actionclick='openPath'
        @datastatechange='dataStateChange'>
      </kendo-grid-component>
    </template>
    <template slot="layout-extend">
      <base-footer>
        <template slot="actions">
          <base-button-responsive mode='primary' :text="labelBtnExcel" icon='excelxls' @click='exportExcel' 
            :loading='isGeneralLoading || loadingExcel' :disabled="loadingExcel"/>
          <base-button-responsive v-if="!isRoleUserConsultaProvider" mode="primary" :text="$t('companies.link_company')" icon="plus" @click="linkSedeCompany" 
            :loading="isGeneralLoading" :disabled="isGeneralLoading"/>
          <base-button-responsive v-if="false" mode="primary" :text="TEST" icon="plus" @click="clientId" />
        </template>
      </base-footer>
      <base-table-select-actions-expand
        :visibility="hasSelected"
        :selected="rowsSelected"
        :total="rowsTotal"
        :baseDropDownVisible="!isRoleUserConsultaProvider"
      >
        <template slot="commons">
          <base-button size="xs" mode="tools" @click="unselect">
            <base-icon name="vall" size="sm" class="mr-1" />
            {{$t('app.unselect')}}
          </base-button>
        </template>
        <template slot="more" v-if="!isRoleUserConsultaProvider">
          <base-button-item-list theme="dark" @click="unlink">
            <base-icon name="unlink" class="mr-2" />
              {{$t('app.unlink_entity')}}
          </base-button-item-list>
        </template>
      </base-table-select-actions-expand>
      <filter-panel :panelOpen="filterPanel" @togglePanel="toggleFilters" @applyFilters="applyFiltersHandler" :vuexnamespace="'linkedCompanies'" />
      <link-company-sociedad-dialog v-if="idCliente" :dialogOpen="linkCompanyToSociedadDialog" :idCliente="idCliente" :linkedCompanies="this.getLinkedCompanies" @toggleDialog="toggleDialogs" @applyDialog="applyLinkHandler" />
      <create-search-dialog
        :numberSearches="numberSearches"
        :idVista="idVista"
        :dialogOpen="saveSearchDialog"
        :tags="tags"
        @toggleDialog="toggleDialogSearches"
        @applyDialog="applySearchHandler" />
      <filter-panel-searches
        ref="filterPanelSearches"
        :idVista="idVista"
        :vuexnamespace="vuexnamespace"
        :panelOpen="searchesPanel"
        @togglePanel="toggleSearchesDialog"
        @applyFilters="applyFiltersHandler"
        @updateNumberSearches="updateNumberSearches"/>
    </template>
  </list-layout>
</template>

<script>
import { bus } from '@/main'
import { i18n } from '@/i18n'

import ListLayout from '@/components/layout/ListLayout.vue'
import FilterPanel from '@/components/filters/SedesLinkedCompaniesFilter.vue'
import FilterPanelSearches from '@/components/searches/SearchesPanel.vue'
import CreateSearchDialog from '@/components/searches/CreateSearchDialog.vue'
import KendoGridComponent from '@/components/KendoGridComponentV2.vue'
import LinkCompanySociedadDialog from '@/components/LinkCompanySociedadDialog.vue'

import { getSociedad } from '@/services/configurations/getSociedad'
import { companies } from '@/services/app/getCompanies'
import { downloadExcel } from '@/services/companies/downloadExcel'
import { linkEmpresasSociedad } from '@/services/configurations/linkEmpresasSociedad'
import { unlinkEmpresasSociedad } from '@/services/configurations/unlinkEmpresasSociedad'

export default {
  name: 'sedes-linked-companies',
  components: {
    ListLayout,
    FilterPanel,
    FilterPanelSearches,
    CreateSearchDialog,
    KendoGridComponent,
    LinkCompanySociedadDialog,
  },
  data: function () {
    return {
      idVista: 84,
      // Searches
      numberSearches: 0,
      saveSearchDialog: false,
      searchesPanel: false,
      // All
      idCliente: 0,
      getLinkedCompanies: null,
      linkCompanyToSociedadDialog: false,
      loadingExcel: false,
      spanish: true,
      header: {
        title: i18n.t('companies.companies_link').toUpperCase(),
        icon: 'config',
        breadcrumb: null,
        url: 'masters/society/details'
      },
      vuexnamespace: 'linkedCompanies',
      selectedField: 'selected',
      filterPanel: false,
      showAllRows: true,
      loadingDataTable: false,
      data: null,
      selected: [],
    }
  },
  computed: {
    isRoleProvider: function () {
      return this.role === 9
    },
    isRoleUserConsultaProvider: function () {
      return this.role === 1 || this.role === 4 || this.role === 9
    },
    id () {
      return parseInt(this.$route.params.id)
    },
    labelBtnExcel: function () {
      if (this.hasSelected) return `${i18n.t('app.export_excel')} (${i18n.t('app.selected')})`
      return i18n.t('app.export_excel')
    },
    kendo: function () {
      return this.$store.getters[this.vuexnamespace + '/getKendo']
    },
    role: function () {
      return this.$store.getters['auth/role']
    },
    isHeadCoreReady: function () {
      return this.$store.getters.isHeadCoreReady
    },
    toggleTableTools: function () {
      return this.selected.length > 0
    },
    rowsSelected: function () {
      return this.selected.length
    },
    rowsTotal: function () {
      return this.selected.length
    },
    setLabelTowShow: function () {
      return this.showAllRows ? i18n.t('app.only_selected') : i18n.t('app.see_all')
    },
    masterFilters: function () {
      return this.$store.getters[this.vuexnamespace + '/getMasterFilters']
    },
    isGeneralLoading: function () {
      return this.$store.getters.isLoading
    },
    headerCoreFilters: function () {
      return this.$store.getters['auth/queryHeaders']
    },
    tags: function () {
      return this.$store.getters[this.vuexnamespace + '/getTags']
    },
    pagination: function () {
      return this.$store.getters[this.vuexnamespace + '/getPaginationInfo']
    },
    columns () {
      return [
        { field: 'selected', width: '50px', headerSelectionValue: this.areAllSelected, reorderable: false, groupable: false },
        ...this.kendo.columns
      ]
    },
    areAllSelected () {
      return this.data.length === this.selected.length
    },
    hasSelected () {
      return this.selected.length > 0
    },
    pgeTypes: function () {
      return this.$store.getters['config/TIPOS_PGE']
    },
    pgeTypesRecepcion: function () {
      return this.$store.getters['config/TIPOS_PGE_RECEPCION']
    }
  },
  watch: {
    headerCoreFilters: {
      // immediate: true,
      deep: true,
      handler: 'headerCoreFiltersHandler'
    },
    getLinkedCompanies: function () {
      return this.linkedCompanies
    },
  },
  mounted: async function () {
    this.$store.commit(this.vuexnamespace + '/setPageSize', this.kendo.take)

    const breadcrumbs = []

    breadcrumbs.push({
      path: 'masters',
      name: i18n.t('masters.header')
    })
    breadcrumbs.push({ path: 'masters/society', name: i18n.t('agenda.sociedad') })
    const contact = await this.downloadData(this.id)
    const cabecera = contact.NameCorporateName || ' '
    breadcrumbs.push({ path: '', name: cabecera })
    this.$store.commit('app/setheaderBreadCrumb', cabecera)

    this.header.breadcrumb = breadcrumbs

    this.disableRoutes(contact)

    this.data = await this.applyFilters()
  },
  methods: {
    linkedCompanies: async function () {
      const objOrder = this.getObjOrderMixin(this.kendo.group, this.kendo.sort)
      const params = {
        idSociedad: this.id,
        paginate: false
      }
      const data = await companies(objOrder, params)
      if (data.blnError === true) {
        this.doFeedback(i18n.t('feedback.error.formated_api_response_error', data))
        return { respuesta: [] }
      } else {
        return { respuesta: data.respuesta || [] }
      }
    },
    disableRoutes: function (contact) {
      const objDisableRoutes = {
        disableSedes: this.isRoleProvider,
        disableUserProvider: this.isRoleUserConsultaProvider || !contact.IsSeflInvoiceSociety
      }
      bus.$emit('disableOptionsContact', objDisableRoutes)
    },
    openPath: function (event) {
      this.$router.push({ name: 'companies/detail', params: { id: event.dataItem.IdCIFEmpresa } })
    },
    toggleFilters: function () {
      this.filterPanel = !this.filterPanel
    },
    toggleDialogs: function () {
      this.linkCompanyToSociedadDialog = !this.linkCompanyToSociedadDialog
    },
    removeFilterTag: function (tag) {
      this.tags.splice(this.tags.indexOf(tag), 1)
    },
    dataStateChange: async function (event) {
      this.data = await this.applyFilters()
    },
    exportExcel: async function () {
      this.$store.commit('app/setLoading', true)
      this.loadingExcel = true
      const data = this.$store.getters[this.vuexnamespace + '/getAppliedFilters']
      const params = {
        idSociedad: this.id,
        CIF: data.cif ? data.cif.value : null,
        razonSocial: data.name ? data.name.value : null,
        idCliente: data.empresa ? data.empresa.value.idCliente : null,
        idDistribuidor: data.distribuidor ? data.distribuidor.value.idDistribuidor : null,
        fechaAltaDesde: data.fechaAltaDesde ? data.fechaAltaDesde.value : null,
        fechaAltaHasta: data.fechaAltaHasta ? data.fechaAltaHasta.value : null,
        estado: data.activo ? data.activo.value : null,
        email: data.email ? data.email.value : null,
        enviarAvisos: data.send_alerts ? data.send_alerts.value : null,
        certAsociado: data.certAsociado ? data.certAsociado.value : null,
        nombreAgrupacion: data.nombreAgrupacion ? data.nombreAgrupacion.value : null,
      }
      const objOrder = this.getObjOrderMixin(this.kendo.group, this.kendo.sort)
      const objColumnas = this.getColumnsGroupExcelMixin(this.kendo.columns, this.kendo.group)
      const payload = { order: objOrder.order, grupos: objColumnas }
      if (this.hasSelected) {
        const selectedIDs = this.selected.map(x => x.IdCIFEmpresa)
        payload.listaIDs = selectedIDs
      }
      try {
        const response = await downloadExcel(payload, params)
        const blob = new Blob([response.data], { type: response.data.type, encoding: 'UTF-8' })
        const link = document.createElement('a')
        link.href = window.URL.createObjectURL(blob)
        let filename = `${i18n.t('companies.companies_link').replaceAll(' ', '').toLowerCase()}.xlsx`
        filename = decodeURI(filename)
        link.download = filename
        link.click()
      } catch (error) {
        console.error(error)
        if (error.response?.data) {
          const errorText = await error.response.data.text()
          this.doFeedback(errorText)
        } else {
          this.doFeedback()
        }
      } finally {
        this.$store.commit('app/setLoading', false)
        this.loadingExcel = false
      }
    },
    applyFilters: async function (eventData) {
      this.loadingDataTable = true
      const data = this.$store.getters[this.vuexnamespace + '/getAppliedFilters']
      const params = {
        idSociedad: this.id,
        CIF: data.cif ? data.cif.value : null,
        razonSocial: data.name ? data.name.value : null,
        idCliente: data.empresa ? data.empresa.value.idCliente : null,
        idDistribuidor: data.distribuidor ? data.distribuidor.value.idDistribuidor : null,
        fechaAltaDesde: data.fechaAltaDesde ? data.fechaAltaDesde.value : null,
        fechaAltaHasta: data.fechaAltaHasta ? data.fechaAltaHasta.value : null,
        estado: data.activo ? data.activo.value : null,
        email: data.email ? data.email.value : null,
        enviarAvisos: data.send_alerts ? data.send_alerts.value : null,
        certAsociado: data.certAsociado ? data.certAsociado.value : null,
        nombreAgrupacion: data.nombreAgrupacion ? data.nombreAgrupacion.value : null,
      }
      const objOrder = this.getObjOrderMixin(this.kendo.group, this.kendo.sort)
      try {
        const data = await this.getItemsData(objOrder, params)
        return data.map(item => { return item })
      } catch (error) {
        this.$store.commit('setIsLoading', false)
        this.doFeedback()
      }
      return this.data
    },
    getItemsData: async function (objOrder, filters) {
      this.$store.commit('setAjaxRequestPending', true)
      this.$store.commit('setIsLoading', true)
      const params = {
        paginate: true,
        results: this.pagination.pageSize,
        page: this.pagination.currentPage,
        ...filters
      }
      const res = await this.getMainData(objOrder, params)
      const pagination = {
        total: res.meta?.total,
        currentPage: res.meta?.currentPage,
        totalPages: res.meta?.lastPage,
        pageSize: res.meta?.perPage
      }
      this.$store.commit(this.vuexnamespace + '/setPaginationInfo', pagination)
      this.$store.commit('setIsLoading', false)
      this.loadingDataTable = false
      return res.respuesta
    },
    async getMainData (objOrder, filters) {
      const params = {
        paginate: true,
        results: this.pagination.pageSize,
        page: this.pagination.currentPage,
        ...filters
      }
      const data = await companies(objOrder, params)
      if (data.blnError === true) {
        this.doFeedback(i18n.t('feedback.error.formated_api_response_error', data))
      }
      return data
    },
    applyFiltersHandler: async function (eventData) {
      this.unselect()
      this.$store.commit(this.vuexnamespace + '/setCurrentPage', 1)
      this.data = await this.applyFilters(eventData)
    },
    changeCurrentPage: async function (event) {
      this.$store.commit(this.vuexnamespace + '/setCurrentPage', event)
      this.data = await this.applyFilters(null)
    },
    changePerPage: async function (event) {
      this.$store.commit(this.vuexnamespace + '/setCurrentPage', 1)
      this.$store.commit(this.vuexnamespace + '/setPageSize', event)
      this.kendo.take = event
      this.data = await this.applyFilters(null)
    },
    removeFilterTagHanlder: function (tag) {
      this.unselect()
      // this.$store.commit(this.vuexnamespace + '/removeTag', tag)
      this.$store.commit(this.vuexnamespace + '/setCurrentPage', 1)
      const filter = this.$store.getters[this.vuexnamespace + '/getAppliedFilters']
      delete filter[tag[0]]
      this.$store.commit(this.vuexnamespace + '/setMasterFilters', filter)
      this.applyFiltersHandler(null)
    },
    headerCoreFiltersHandler: function (obs) {
      if (this.isHeadCoreReady) {
        this.applyFilters(null)
      }
    },
    removeAllTagsHandler: function () {
      this.unselect()
      this.$store.commit(this.vuexnamespace + '/setCurrentPage', 1)
      this.$store.commit(this.vuexnamespace + '/resetMasterFilters')
      this.applyFiltersHandler(null)
    },
    downloadData: async function (id) {
      let contact = null
      try {
        this.$store.commit('setIsLoading', true)

        const params = {
          IdSociedad: id
        }
        contact = await getSociedad(params)
        if (contact.blnError === true) {
          this.doFeedback(i18n.t('feedback.error.formated_api_response_error', contact))
        } else {
          this.idCliente = parseInt(contact.respuesta.IdCliente)
          contact = contact.respuesta
        }
      } catch (error) {
        this.doFeedback()
      } finally {
        this.$store.commit('setIsLoading', false)
      }
      return contact
    },
    applyLinkHandler: async function (estados) {
      await this.linkHandler(estados)
      this.data = await this.applyFilters()
    },
    linkHandler: async function (cifEmpresas) {
      try {
        this.$store.commit('setIsLoading', true)
        const payload = { IdSociedad: this.id, IdCifEmpresas: cifEmpresas }
        const response = await linkEmpresasSociedad(payload)
        if (response.blnError === true) {
          this.doFeedback(i18n.t('feedback.error.formated_api_response_error', response))
        } else {
          this.doFeedback(i18n.t('feedback.success.entity_linked_msg'), 'success')
          this.data = await this.applyFilters()
          this.toggleDialogs()
        }
      } catch (error) {
        this.doFeedback()
      } finally {
        this.$store.commit('setIsLoading', false)
      }
    },
    unselect: function () {
      this.selected = []
    },
    unlink: async function () {
      const IdCifEmpresas= this.selected || []
      await this.unlinkHandler(IdCifEmpresas)
      this.data = await this.applyFilters()
    },
    unlinkHandler: async function (cifEmpresas) {
      try {
        this.$store.commit('setIsLoading', true)
        const payload = { IdSociedad: this.id, IdCifEmpresas: cifEmpresas }
        const response = await unlinkEmpresasSociedad(payload)
        if (response.blnError === true) {
          this.doFeedback(i18n.t('feedback.error.formated_api_response_error', response))
        } else {
          this.doFeedback(i18n.t('feedback.success.entity_unlinked_msg'), 'success')
          this.data = await this.applyFilters()
          this.unselect()
        }
      } catch (error) {
        this.doFeedback()
      } finally {
        this.$store.commit('setIsLoading', false)
      }
    },
    linkSedeCompany: function () {
      this.linkCompanyToSociedadDialog = !this.linkCompanyToSociedadDialog
    },
    toggleSearchesDialog: function () {
      this.searchesPanel = !this.searchesPanel
    },
    saveTagsHandler: function () {
      this.saveSearchDialog = !this.saveSearchDialog
    },
    toggleDialogSearches: function () {
      this.saveSearchDialog = !this.saveSearchDialog
    },
    applySearchHandler: async function () {
      this.toggleDialogSearches()
      // Manda actualizar lista de búsquedas
      this.$refs.filterPanelSearches.updateData()
    },
    updateNumberSearches: async function (number) {
      this.numberSearches = number
    },
  }
}
</script>

<style lang="scss" scoped></style>
